var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgAutoOrange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "104px",
    height: "118px",
    viewBox: "0 0 104 118",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4 25\u5907\u4EFD 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M32,0 C49.673112,0 64,14.360362 64,32.0747664 C64,41.7358195 59.7386452,50.3992543 52.9971751,56.2796696 L32.0500895,78 L11.048967,56.3198412 C4.28080533,50.4387475 0,41.7578428 0,32.0747664 C0,14.360362 14.326888,0 32,0 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-53.1%",
    y: "-33.3%",
    width: "206.2%",
    height: "187.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 8,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-37.5%",
    y: "-39.8%",
    width: "175.0%",
    height: "179.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u65B0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7AD9\\u70B9\\u5730\\u56FE3\\u5907\\u4EFD",
    transform: "translate(-344.000000, -1381.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-25\\u5907\\u4EFD-3",
    transform: "translate(364.000000, 1393.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5F62\\u72B6\\u7ED3\\u5408"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFAD08",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u62A5\\u8B66\\u5907\\u4EFD",
    filter: "url(#filter-3)",
    transform: "translate(16.000000, 16.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#000000",
    opacity: 0,
    x: 0,
    y: 0,
    width: 30.1152735,
    height: 30.1152735
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9480919,7.52881839 C19.344212,7.52881839 21.6421933,8.48067341 23.3365061,10.1749862 C25.0308189,11.869299 25.9826739,14.1672803 25.9826739,16.5634005 L25.9826739,24.0922188 C25.9826739,24.4915722 25.8240314,24.8745691 25.541646,25.1569545 C25.2592605,25.43934 24.8762636,25.5979825 24.4769103,25.5979825 L9.41927348,25.5979825 C8.58766316,25.5979825 7.9135098,24.9238292 7.9135098,24.0922188 L7.9135098,16.5634005 C7.9135098,11.5737386 11.95843,7.52881839 16.9480919,7.52881839 L16.9480919,7.52881839 Z M16.9480919,21.8335733 C19.858728,21.8335733 22.2182647,19.4740366 22.2182647,16.5634005 C22.2182647,13.6527643 19.858728,11.2932276 16.9480919,11.2932276 C14.0374558,11.2932276 11.677919,13.6527643 11.677919,16.5634005 C11.677919,19.4740366 14.0374558,21.8335733 16.9480919,21.8335733 L16.9480919,21.8335733 Z M16.9480919,20.3278096 C14.8690661,20.3278096 13.1836827,18.6424262 13.1836827,16.5634005 C13.1836827,14.4843747 14.8690661,12.7989913 16.9480919,12.7989913 C19.0271177,12.7989913 20.7125011,14.4843747 20.7125011,16.5634005 C20.7125011,18.6424262 19.0271177,20.3278096 16.9480919,20.3278096 Z M6.40774612,27.1037462 L27.4884376,27.1037462 C28.3200479,27.1037462 28.9942012,27.7778996 28.9942012,28.6095099 C28.9942012,29.4411202 28.3200479,30.1152735 27.4884376,30.1152735 L6.40774612,30.1152735 C5.57613581,30.1152735 4.90198245,29.4411202 4.90198245,28.6095099 C4.90198245,27.7778996 5.57613581,27.1037462 6.40774612,27.1037462 L6.40774612,27.1037462 Z M16.9480919,0 C17.7797022,0 18.4538555,0.674153361 18.4538555,1.50576368 L18.4538555,3.01152735 C18.4538555,3.84313765 17.7797022,4.51729097 16.9480919,4.51729097 C16.1164816,4.51729097 15.4423282,3.84313765 15.4423282,3.01152735 L15.4423282,1.50576368 C15.4423282,0.674153361 16.1164815,0 16.9480919,0 L16.9480919,0 Z M26.2416653,3.01905617 C26.5645432,3.25407506 26.7808357,3.60773126 26.8429605,4.00222403 C26.9050854,4.3967168 26.8079536,4.79973115 26.5729333,5.12260803 L25.68905,6.34227661 C25.2000631,7.01504935 24.2582709,7.16403725 23.5854982,6.67505038 C22.9127254,6.18606352 22.7637375,5.24427127 23.2527244,4.57149852 L24.1381134,3.35182995 C24.3731323,3.02895201 24.7267885,2.81265955 25.1212813,2.7505347 C25.5157741,2.68840986 25.9187884,2.7855416 26.2416653,3.02056194 L26.2416653,3.01905617 Z M31.9259232,10.9243155 C32.1828378,11.7151727 31.7500498,12.5645697 30.9592229,12.8215777 L29.5287474,13.2883645 C28.7374702,13.5457478 27.8873628,13.1129414 27.6299794,12.3216642 C27.3725961,11.530387 27.8054025,10.6802796 28.5966797,10.4228962 L30.0286609,9.9576152 C30.8195182,9.70070055 31.6689152,10.1334886 31.9259232,10.9243155 Z M1.95670869,10.9243155 C2.21371666,10.1334886 3.06311368,9.70070055 3.85397093,9.9576152 L5.28595218,10.4244019 C5.81399929,10.5771694 6.21683722,11.0055482 6.33689642,11.5419784 C6.45695561,12.0784087 6.2751552,12.6376362 5.86260618,13.0009198 C5.45005716,13.3642033 4.87232551,13.4738067 4.35539023,13.2868587 L2.92491474,12.8215777 C2.54486716,12.698467 2.22931856,12.4293773 2.0477301,12.073543 C1.86614165,11.7177087 1.83339862,11.3042984 1.95670869,10.9243155 L1.95670869,10.9243155 Z M7.65451845,3.01905617 C7.97776473,2.78434784 8.38102829,2.68770467 8.77554779,2.75039853 C9.1700673,2.8130924 9.52350633,3.02998466 9.75807031,3.35333571 L10.6434593,4.57149852 C10.9794357,5.00572462 11.0524418,5.58839827 10.8339822,6.09209244 C10.6155226,6.5957866 10.1402281,6.94065417 9.59361396,6.99208769 C9.04699982,7.0435212 8.51571695,6.79336728 8.20713372,6.33926508 L7.32174468,5.12110227 C7.08688046,4.79804068 6.98999305,4.39490177 7.05240239,4.00039567 C7.11481173,3.60588956 7.33140402,3.25234193 7.65451845,3.01755041 L7.65451845,3.01905617 Z",
    id: "\\u5F62\\u72B6",
    fill: "#FFFFFF"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgAutoOrange);
export default __webpack_public_path__ + "static/media/img_auto_orange.6cd57188d7de6a0ae52d28c26a1b8951.svg";
export { ForwardRef as ReactComponent };